
import { getUA } from '@kmt/ua'
import dayjs from 'dayjs'

const ua = getUA({ isServer: false })
const isWoa = ua.isInWoa

// 单点登录
export function toLogin () {
  const SINGLE_SIGN = 'https://account.kdocs.cn/passport/singlesign'
  const cb = encodeURIComponent(window.location.href)
  const accountOrigin = 'https://account.wps.cn'
  const failpageCb = encodeURIComponent(`${SINGLE_SIGN}?cb=${cb}`)
  const failpage = encodeURIComponent(`${accountOrigin}/?cb=${failpageCb}`)
  const loginUrl = `${SINGLE_SIGN}?cb=${cb}&failpage=${failpage}&qrcode=kdocs`
  window.location.replace(loginUrl)
}

export function openWpsUrl (url) {
  if (isWoa) {
    window.open(`ksoxz://xz.wps.cn/webview?url=${encodeURIComponent(url)}`)
  } else {
    window.open(url)
  }
}

export function formatTime (time, withSecond) {
  return withSecond ? dayjs(time).format('HH:mm:ss') : dayjs(time).format('HH:mm')
}

export function formatDate (time, withYear = true) {
  return withYear ? dayjs(time).format('YYYY/MM/DD') : dayjs(time).format('MM/DD')
}

export const convertSecondsToHMS = (seconds) => {
  const hours = Math.floor(seconds / 3600)
  const minutes = Math.floor((seconds % 3600) / 60)
  const remainingSeconds = seconds % 60
  let timeString = ''
  if (hours > 0) {
    timeString += `${hours}小时`
  }
  if (hours > 0 || minutes > 0) {
    timeString += `${minutes}分`
  }
  timeString += `${remainingSeconds}秒`
  return timeString.trim()
}

let os = ''

function _getOS () {
  const userAgent = navigator.userAgent || navigator.vendor || window.opera
  if (/windows phone/i.test(userAgent)) {
    return 'Windows Phone'
  }
  if (/android/i.test(userAgent)) {
    return 'Android'
  }
  if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
    return 'iOS'
  }
  if (/Win(dows)?/.test(userAgent)) {
    return 'Windows'
  }
  if (/Mac/i.test(userAgent)) {
    return 'MacOS'
  }
  if (/Linux/i.test(userAgent)) {
    return 'Linux'
  }
  return 'none'
}

export function getOS () {
  if (os) {
    return os
  }
  os = _getOS()
  return os
}
// 获取 GMT 偏移量 比如 GMT+08:00 GMT+05:45
export function getGMTOffset () {
  const offset = new Date().getTimezoneOffset()
  const absOffset = Math.abs(offset)
  const hours = String(Math.floor(absOffset / 60)).padStart(2, '0')
  const minutes = String(absOffset % 60).padStart(2, '0')
  const sign = offset > 0 ? '-' : '+'
  return `GMT${sign}${hours}:${minutes}`
}

export function getUrlParam (url, paramName) {
  const queryString = (url || window.location.href).split('?')[1]
  if (!queryString) return null
  const params = queryString.split('&').reduce((acc, param) => {
    const [key, value] = param.split('=')
    acc[key] = value
    return acc
  }, {})
  return params[paramName]
}

export function addUrlParam (url, paramName, paramValue) {
  const separator = url.indexOf('?') !== -1 ? '&' : '?'
  return `${url}${separator}${paramName}=${encodeURIComponent(paramValue)}`
}

export function sleep (ms) {
  return new Promise(resolve => setTimeout(resolve, ms))
}

// 生成占位用户头像的函数
export const generatePlaceholderAvatar = (name) => {
  const colors = ['#4F46E5', '#0EA5E9', '#10B981', '#F59E0B', '#EF4444']
  // 同一个名字，生成同一个头像
  const hash = name.split('').reduce((acc, char) => {
    return acc + char.charCodeAt(0)
  }, 0)
  const colorIndex = hash % colors.length
  const color = colors[colorIndex]
  return `https://ui-avatars.com/api/?background=${color.substring(1)}&color=fff&name=${name}`
}

// 获取文件名，不带后缀
export const getFileName = (fileName) => {
  return typeof fileName === 'string' ? fileName.split('.').slice(0, -1).join('.') : fileName
}

// 获取文件后缀名
export const getFileExtension = (fileName) => {
  return fileName.split('.').pop()
}